import React from 'react';

import { Paper, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    buscadorVacio: {
        padding:'20px',
        margin: '20px',
        color: '#606060'
    }
});

export const ResultadoVacio = () => {
    const clases = useStyles();
    return (
        <Paper className={clases.buscadorVacio} elevation={0} square>
            <div>
                <h4>No se encontró nada que coincida con la búsqueda</h4>
                <div>Sugerencias</div>
                <ul>
                    <li>Asegúrese de que todas las palabras estén escritas correctamente</li>
                    <li>Pruebe distintos términos de búsqueda</li>
                    <li>Pruebe términos de búsqueda más generales</li>
                    <li>Pruebe menos términos de búsqueda</li>
                </ul>
            </div>
        </Paper>
    );
}